import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import Tile from '../common/Tile';
import '../common/rtCommon.css';
import '../common/Tile.css';
import './PaymentManagement.css';

const tiles = [
    {
        icon: '📅',
        title: 'Generate Monthly Rental Invoice',
        description: 'Auto-generate rental invoices for all active paying guests for the current month',
        url: 'generate-monthly',
        access_roles: ['RT_Admin']
    },
    {
        icon: '🧾',
        title: 'Create Invoice',
        description: 'Manually create new invoices for specific paying guests',
        url: 'invoices/create',
        access_roles: ['RT_Admin']
    },
    {
        icon: '📄',
        title: 'View Draft Invoices',
        description: 'View and manage all invoices with filtering options',
        url: 'view-draft-invoices',
        access_roles: ['RT_Admin']
    },
    {
        icon: '📬',
        title: 'View Unpaid Invoices',
        description: 'View all unpaid invoices (sent and overdue) with payment options',
        url: 'view-unpaid-invoices',
        access_roles: ['RT_Admin']
    },
    {
        icon: '💵',
        title: 'Add Payment',
        description: 'Record payments received from paying guests',
        url: 'add',
        access_roles: ['RT_Admin']
    },
    {
        icon: '💰',
        title: 'View Payments',
        description: 'View detailed payment records with filtering options',
        url: 'view-payments',
        access_roles: ['RT_Admin']
    }
];

const PaymentManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="rt-layout">
      <Menu className="rt-menu" activePath={location.pathname} />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Payment Management</h2>
        </div>
        <div className="rt-main-section">
          <div className="rt-tiles-grid">
            {tiles.map((tile, idx) => (
              <Tile
                key={idx}
                icon={tile.icon}
                title={tile.title}
                description={tile.description}
                disabled={tile.disabled}
                access_roles={tile.access_roles}
                onClick={() => tile.url && navigate(tile.url)}
                tabIndex={0}
                role="button"
                onKeyPress={e => { if (e.key === 'Enter' && tile.url) navigate(tile.url); }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentManagement;